import { render, staticRenderFns } from "./FieldObrigatorityModal.vue?vue&type=template&id=208ddee9&scoped=true&"
import script from "./FieldObrigatorityModal.vue?vue&type=script&lang=js&"
export * from "./FieldObrigatorityModal.vue?vue&type=script&lang=js&"
import style0 from "./FieldObrigatorityModal.vue?vue&type=style&index=0&id=208ddee9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208ddee9",
  null
  
)

export default component.exports